import brandTheme from '../../../../../../Assets/Styles/brandTheme'

const { colors } = brandTheme()

export const chartOptions = {
  chart: {
    type: 'line',
    height: '30%',
  },
  title: {
    text: '',
  },
  colors: [colors.secondary],
  credits: false,
  legend: {
    enabled: true,
  },
  allowDecimals: false,
  rangeSelector: {
    selected: 1,
  },
  navigator: {
    enabled: false,
  },
  yAxis: {
    title: {
      text: '',
    },
  },
  plotOptions: {
    series: {
      events: {
        legendItemClick: function() {
          return false
        },
      },
    },
    line: {
      marker: {
        enabled: false,
      },
    },
  },
}



// WEBPACK FOOTER //
// ./src/Containers/StatsOverview/components/CampaignPerforming/Charts/ScanUniqueGraph/options.js